module.exports = __webpack_public_path__ + "static/sportsconnectvideos-c7cb190abc454c4143fe6b9f6d913eb1.jpg";